import { Input } from "@/components/ui/input";

export interface EmailInputProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function EmailInput({
  label,
  description,
  headerRight,
  value,
  onChange,
  placeholder = "email@example.com",
  required = false,
}: EmailInputProps) {
  const currentValue = value ?? "";
  const isValid = !currentValue || EMAIL_REGEX.test(currentValue);

  return (
    <div className="space-y-2">
      {label && (
        <div className="flex items-center justify-between gap-3">
          <label className="field-label block">
            {label}
            {required && <span className="ml-1 text-red-500">*</span>}
          </label>
          {headerRight}
        </div>
      )}
      {description && <p className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{description}</p>}
      <Input
        type="email"
        value={currentValue}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className={`text-ds-text-primary dark:text-white ${
          !isValid ? "border-red-500 focus-visible:ring-red-500/20 dark:border-red-500" : ""
        }`}
      />
      {!isValid && <p className="micro-label text-red-500 dark:text-red-400">Please enter a valid email address</p>}
    </div>
  );
}
